import { Slider } from "antd";
import styled from "styled-components";

export const Container = styled.div`
padding-left : 3rem;
height: 100%;
padding-right : 3rem;
background-color : ${props => props.theme.backgroundColor};
overflow-y: scroll;
`;

export const MySlider = styled(Slider)`
margin : 2rem 5rem 5rem 5rem;
`
